export default "__VITE_ASSET__DxkZ7p7M__"